import {Dispatch} from "redux";
import {HomeAction, homeActionTypes} from "../../types/home";
import {getMessageList} from '../../../services/info'

export const leftMenuToggle = (payload?:any) => {
  return (dispatch: Dispatch<HomeAction>) => {
    dispatch({
      type: homeActionTypes.LEFTMENUTOGGLE,
      payload: payload
    })
  }
}

export const rightMenuToggle = (payload?:any) => {
  return (dispatch: Dispatch<HomeAction>) => {
    dispatch({
      type: homeActionTypes.RIGHTMENUTOGGLE,
      payload: payload
    })
  }
}

export const settingMenuToggle = (payload?:any) => {
  return (dispatch: Dispatch<HomeAction>) => {
    dispatch({
      type: homeActionTypes.SETTINGMENUTOGGLE,
      payload: payload
    })
  }
}


export const saveTemplateLoading = () => {
  return (dispatch: Dispatch<HomeAction>) => {
    dispatch({
      type: homeActionTypes.REQUESTSAVEDOCUMENT,
    })
  }
}

export const saveTemplateSuccess = () => {
  return (dispatch: Dispatch<HomeAction>) => {
    dispatch({
      type: homeActionTypes.SUCCESSSAVEDOCUMENT,
    })
  }
}
export const getMessageLists = () => {
  return (dispatch: Dispatch<HomeAction>) => {
    return new Promise(() => {
      dispatch({type: homeActionTypes.REQUESTGETMESSAGELIST})
        const messageList_cash = [
            // {
            //     "messageKey": "INFO.FORGOT_PASS",
            //     "messageTextType": "1",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.WHATSAPP",
            //     "messageTextType": "1",
            //     "textAZE": " ",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.NEW_PASS",
            //     "messageTextType": "1",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.ASAN",
            //     "messageTextType": "1",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.NEW_PASS",
            //     "messageTextType": "2",
            //     "textAZE": "yeni şifrə ",
            //     "textENG": null,
            //     "textRU": null,
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.WHATSAPP",
            //     "messageTextType": "3",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.LAST_TRANSACTION",
            //     "messageTextType": "3",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_OWN",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_OTHER",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_AZIPS",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_XOHKS",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_DXA",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_VAT",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_IPS_OTHER",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_IPS_DXA",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_IPS_VAT",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_SWIFT",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_RUB",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": null,
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_MASS",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": null,
            //     "textRU": null,
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.TR_MASS_CHECKBOX",
            //     "messageTextType": "7",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.ALL_TRANSACTION",
            //     "messageTextType": "4",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.SALARY_PAY",
            //     "messageTextType": "5",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.SALARY_EMPLOYEE",
            //     "messageTextType": "5",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.SALARY_EMP_LIST",
            //     "messageTextType": "5",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.SALARY_STATEMENT",
            //     "messageTextType": "5",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_PERSONAL",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_TIN",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_SMS",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_PER_PIN",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_TIN_PIN",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_PER_SMS_YES",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_PER_SMS_NO",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_TIN_SMS_YES",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.CARD_TIN_SMS_NO",
            //     "messageTextType": "6",
            //     "textAZE": "",
            //     "textENG": "",
            //     "textRU": "",
            //     "messageImage": null
            // },
            // {
            //     "messageKey": "INFO.WELLCOME",
            //     "messageTextType": "1",
            //     "textAZE": null,
            //     "textENG": null,
            //     "textRU": null,
            //     "messageImage": null
            // },
        ]
      getMessageList()
          .then(response => {
            if(response.messageList !== undefined && response.messageList !== null && response.messageList.length > 0){
                response.messageList.map((messageListCashKey) => {
                  messageList_cash.push(messageListCashKey)
                  // var index = messageList_cash.findIndex((item) => item.messageKey === messageListCashKey.messageKey && item.messageTextType === messageListCashKey.messageTextType)
                  // if(index !==null && index !== undefined && index > -1) {
                  //     messageList_cash[index].textAZE = messageListCashKey.textAZE
                  //     messageList_cash[index].textENG = messageListCashKey.textENG
                  //     messageList_cash[index].textRU = messageListCashKey.textRU
                  // }
              })
            }
            dispatch({
              payload: {
                result: messageList_cash,
              },
              type: homeActionTypes.SUCCESSGETMESSAGELIST,
            })
          })
          .catch(error => {
              dispatch({
                  type: homeActionTypes.ERRORGETMESSAGELIST,
              })
          })
    })
  }}